import React from 'react'

import { RadioOption as UIRadioOption } from '@carsys/ui'

type UIRadioOptionProps = React.ComponentProps<typeof UIRadioOption>

interface RadioOptionProps extends Omit<UIRadioOptionProps, 'label' | 'value'> {
  label: UIRadioOptionProps['label']
  value: any
  RadioControl?: React.ReactElement
}

export function RadioOption(props: RadioOptionProps) {
  return <UIRadioOption {...props} />
}
